import React from 'react';

import { SimpleBarChart } from '@magoosh/lib/charts';

import StatisticData from '../statistic_data';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  examName: string;
  filters: any;
}

const PerformanceByDifficultyChart: React.FC<Props> = (props) => {
  const loadingPlaceholder = (
    <SimpleBarChart
      colorPalette={{ dark: colors.gray85, light: colors.grayLightest }}
      data={[
        {
          label: 'Easy',
          percentage: true,
          value: 60
        },
        {
          label: 'Medium',
          percentage: true,
          value: 40
        },
        {
          label: 'Hard',
          percentage: true,
          value: 20
        },
        {
          label: 'Very Hard',
          percentage: true,
          value: 0
        }
      ]}
    />
  );

  if (!props.filters) {
    return loadingPlaceholder;
  } else {
    return (
      <StatisticData
        filters={props.filters}
        name="performance_by_difficulty"
      >
        <StatisticData.Loading>
          {loadingPlaceholder}
        </StatisticData.Loading>

        {/* @ts-ignore */}
        <SimpleBarChart
          colorPalette={{ dark: colors.dataDarkPurple, light: colors.dataMutedPurple }}
        />
      </StatisticData>
    );
  }
};

export default PerformanceByDifficultyChart;
